import React, {useState} from 'react';
import {useAppDispatch} from "../app/hooks";
import {Button} from "antd";
import {setMode} from "../features/omikuji/omikujiSlice";

export function Screen10_Error(props: any) {
    const dispatch = useAppDispatch();
    return <>
        <p>screen10 - エラーが発生しました</p>
        <Button onClick={() => dispatch(setMode("mode10_Error"))}>同意する</Button>
    </>
}
